import { useState } from "react";

export function useMappedBooleanState() {
  const [value, setValue] = useState({});

  const setPositive = (id) => {
    setValue((prev) => {
      return { ...prev, [id]: true };
    });
  };

  const setNegative = (id) => {
    setValue((prev) => {
      return { ...prev, [id]: false };
    });
  };

  return [value, setPositive, setNegative];
}

export default useMappedBooleanState;
